// Standalone, zod-free home for ShopperFacingBillingStatus. Lives apart from
// ./team so that value-importing this enum (e.g. from ./widget, which the
// checkout UI extension bundle pulls in) does not drag in the ~3000-line,
// zod-heavy ./team module. ./team re-exports it for existing
// `@redotech/redo-team-common/team` importers.

export enum ShopperFacingBillingStatus {
  UP_TO_DATE = "up_to_date",
  MISSING_BILLING_INFO = "missing_billing_info",
  BILLING_FAILURE = "billing_failure",
}
